import {
  // -- GET (list)
  GET_PROJECT_RESOURCES_SUCCESS,
  GET_PROJECT_RESOURCES_FAILURE,
  // -- CREATE
  CREATE_PROJECT_RESOURCE_SUCCESS,
  CREATE_PROJECT_RESOURCE_FAILURE,
  // -- UPDATE
  UPDATE_PROJECT_RESOURCE_SUCCESS,
  UPDATE_PROJECT_RESOURCE_FAILURE,
  // -- DELETE
  DELETE_PROJECT_RESOURCE_SUCCESS,
  DELETE_PROJECT_RESOURCE_FAILURE,
  // -- SEARCH
  SEARCH_PROJECT_RESOURCES
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const projectResources = (state = {}, action) => {
  switch (action.type) {
    // -- GET PROJECT RESOURCES (list)
    case GET_PROJECT_RESOURCES_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectResources.GET_PROJECT_RESOURCES_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_PROJECT_RESOURCES_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectResources.GET_PROJECT_RESOURCES_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE PROJECT RESOURCE
    case CREATE_PROJECT_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectResources.CREATE_PROJECT_RESOURCE_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_PROJECT_RESOURCE_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectResources.CREATE_PROJECT_RESOURCE_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE PROJECT RESOURCE
    case UPDATE_PROJECT_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectResources.UPDATE_PROJECT_RESOURCE_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_RESOURCE_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectResources.UPDATE_PROJECT_RESOURCE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE PROJECT RESOURCE
    case DELETE_PROJECT_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectResources.DELETE_PROJECT_RESOURCE_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_RESOURCE_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectResources.DELETE_PROJECT_RESOURCE_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH PROJECT
    case SEARCH_PROJECT_RESOURCES: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
